( function () {
	'use strict';

	function manageShare ( ) {
		return {
			'templateUrl'      : '/templates/templates/manage-share/manage-share.html',
			'restrict'         : 'E',
			'replace'          : true,
			'controller'       : 'ManageShareCtrl',
			'controllerAs'     : 'vm',
			'bindToController' : true,
			'scope'            : {
				'collection' : '=',
				'openItem'   : '&',
				'modelType'  : '@',
				'templateId' : '=',
				'parentPriv' : '='
			}
		};
	}

	angular
		.module( 'app.templates' )
		.directive( 'manageShare', manageShare );
} )( );
